<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogController"
    :width="width"
    :before-close="cancel"
    :append-to-body="appendToBody"
    :top="top"
    center
    :close-on-click-modal="closeOnClickModal"
  >
    <slot></slot>
    <div slot="footer" v-if="showConfirm && showCancel">
      <el-button @click="cancel" v-show="showCancel" size="small">取 消</el-button>
      <el-button
        :disabled="disabledConfirm"
        type="primary"
        size="small"
        :loading="loading"
        v-show="showConfirm"
        @click="confirm"
        v-preventReClick
      >确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
// import { preventReClick } from '@/utils/preventClick'
export default {
  props: {
    title: {
      type: String,
      default: '弹窗标题'
    },
    width: {
      type: String,
      default: '65%'
    },
    dialogController: {
      type: Boolean,
      default: false
    },
    disabledConfirm: {
      type: Boolean,
      default: false
    },
    showCancel: {
      type: Boolean,
      default: true
    },
    showConfirm: {
      type: Boolean,
      default: true
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    loading:{
      type:Boolean,
      default: false
    },
    top:{
      type: String,
      default: '15vh'
    },
    closeOnClickModal:{
      type: Boolean,
      default: true
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    },
    confirm () {
      this.$emit('confirm')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialogPanel/index.vue